// extracted by mini-css-extract-plugin
export default {"wrapper":"ingredients_wrapper__AV4lX"};